import React from 'react';

function AboutOurMissionSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '64px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 48,
      flexWrap: 'wrap'
    },
    leftCol: {
      flex: '1 1 0',
      minWidth: 260,
      maxWidth: 520
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '100%',
      letterSpacing: '-0.01em',
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    overlineRule: {
      display: 'inline-block',
      width: 150,
      height: 0,
      borderBottom: '2px solid #E73123',
      marginLeft: 12,
      verticalAlign: 'middle',
      opacity: 1
    },
    titleRed: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#E73123',
      margin: '8px 0 0 0'
    },
    titleBlack: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 28,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: '4px 0 0 0'
    },
    body: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '28px',
      letterSpacing: 0,
      color: '#838383',
      margin: '16px 0 0 0'
    },
    rightCol: {
      flex: '0 0 520px',
      width: 520,
      maxWidth: '100%',
      minWidth: 0
    },
    image: {
      width: '100%',
      maxWidth: 520,
      aspectRatio: '1',
      objectFit: 'cover',
      display: 'block',
      opacity: 1
    }
  };

  return React.createElement('section', { style: styles.section },
    React.createElement('div', { style: styles.leftCol },
      React.createElement('h2', { style: styles.overline },
        'OUR MISSION',
        React.createElement('span', { style: styles.overlineRule })
      ),
      React.createElement('h3', { style: styles.titleRed }, 'DELIVERING EXCELLENCE'),
      React.createElement('h3', { style: styles.titleBlack },
        'THROUGH QUALITY,',
        React.createElement('br'),
        'COMMITMENT, AND CLIENT',
        React.createElement('br'),
        'SATISFACTION'
      ),
      React.createElement('p', { style: styles.body },
        "The company's mission is to satisfy our clients with our excellent, high-quality, and sufficient construction services and products, as well as our team's passion and commitment."
      )
    ),
    React.createElement('div', { style: styles.rightCol },
      React.createElement('img', {
        src: '/ourmission.jpg',
        alt: 'Construction site - Sunrise Properties mission',
        style: styles.image
      })
    )
  );
}

export default AboutOurMissionSection;
